import { render, staticRenderFns } from "./tableBox.vue?vue&type=template&id=098bfb2b&scoped=true&"
import script from "./tableBox.vue?vue&type=script&lang=js&"
export * from "./tableBox.vue?vue&type=script&lang=js&"
import style0 from "./tableBox.vue?vue&type=style&index=0&id=098bfb2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098bfb2b",
  null
  
)

export default component.exports